import { render, staticRenderFns } from "./Deliveries.vue?vue&type=template&id=87bdd40e&scoped=true"
import script from "./Deliveries.vue?vue&type=script&lang=js"
export * from "./Deliveries.vue?vue&type=script&lang=js"
import style0 from "./Deliveries.vue?vue&type=style&index=0&id=87bdd40e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bdd40e",
  null
  
)

export default component.exports